import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../../Util/Session/session.service';
import { EmployeedetailService } from '../../Model/EmpDetail/employeedetail.service';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-emp-detail',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, NgSelectModule],
  templateUrl: './emp-detail.component.html',
  styleUrl: './emp-detail.component.scss'
})
export class EmpDetailComponent {
  selectedFieldName: any = null;
  empMasterId: any;
  showDetail = false;

  constructor(
    public activeModal: NgbActiveModal,
    private session: SessionService,
    private employeeDetail: EmployeedetailService,
    protected common: CommonService,
  ) { }

  ngOnInit(): void {
    this.GetEmployeeSearchFieldsCombo();
  }

  isDisabled: boolean = false;
  employees: any;
  searchBy: any;
  selectedEmployee: any;
  selectedEmployeeId: any = null;
  typedValue: any;

  onDropdown2Change(selectedOption: any): void {
    this.LoadEmployeeSearch(this.selectedFieldName, this.typedValue, 'S', 0);
    this.empMasterId = selectedOption.EmpmasterID;
    this.onSearch();
  }

  onInputChange(event: any): void {
    this.typedValue = event?.target?.value;
    this.LoadEmployeeSearch(this.selectedFieldName, this.typedValue, 'S', 0);
  }

  onSearch() {
    this.LoadEmployeeSearch(this.selectedFieldName, this.typedValue, 'D', this.empMasterId);
    this.showDetail = true;
  }

  onDropdownClear(type: string) {
    if (type === 'Employeename') {
      this.showDetail = false;
    } else if (type === 'feildname') {
      this.showDetail = false;
    }
  }

  GetEmployeeSearchFieldsCombo() {
    try {
      this.isDisabled = true
      this.employeeDetail.GetEmployeeSearchFieldsCombo({
        TokenUserName: this.session.User.TokenUserName,
        TokenPassword: this.session.User.TokenPassword,
        TokenAppName: this.session.User.TokenAppName,
        Token: this.session.User.Token,
        SessionID: this.session.User.SessionID,
        OpType: this.session.User.OpType,
        UserType: this.session.User.UserType
      }).subscribe({
        next: (response) => {
          this.searchBy = response.Table;
          this.selectedFieldName = this.searchBy[0].FieldNames;
          this.isDisabled = false;
        },
      });
    } catch (error) {
      console.error('Error occurred:', error);
      this.isDisabled = false;
    }
  }

  LoadEmployeeSearch(field: string, value: string, selectType: string, empMasterId: number) {
    try {
      this.isDisabled = true
      this.employeeDetail.LoadEmployeeSearch({
        SearchField: field,
        SearchValue: value,
        SelectType: selectType,
        EmpMasterID: empMasterId
      }).subscribe({
        next: (response) => {
          if (selectType == 'D') {
            this.selectedEmployee = response.Table[0];
            this.isDisabled = false
          } else if (selectType === 'S') {
            this.employees = response.Table;
            this.isDisabled = false
          }
        },
      });
    } catch (error) {
      console.error('Error occurred:', error);
      this.isDisabled = false
    }
  }

  cancel() {
    this.activeModal.close();
  }

}
